import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import Chip from '@material-ui/core/Chip';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@material-ui/core'
import { useHistory } from "react-router-dom";

import { acceptChallenge } from '../../actions/challenge-actions';
import { Coin } from '../shared/component'
import useStyles from '../../styles/components/survey/stylesSurvey'
import ChallengeContext from '../../context/challenge-context'
import { Claims } from '../../utils/services/cache/ClientCache'

const ChallengeHolder = () => {
    const classes = useStyles();
    const history = useHistory();
    const { challengeContext } = useContext(ChallengeContext);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const onLoadMore = () => setRowsPerPage(rowsPerPage + 5)

    const handleClickOpen = (id) => {
        return history.push(`/ChallengeDetail/${id}`);
    }

    const handleAccept = async (challengeId, memberId) => {
        let data = {
            MemberId: memberId,
            ChallengeId: challengeId
        }

        let response = await acceptChallenge(JSON.stringify(data));
        if (response > 200 || response.status === "Failed") {
            alert("Something went wrong!");
        }
        if (response.status === "Success") {
            history.push(`/ChallengeDetail/${challengeId}`);
        }
    }

    return (
        <>
            {
                challengeContext.onGoingChallenges.length > 0 ?
                    challengeContext.onGoingChallenges.slice(0, rowsPerPage).map((challenge) => (
                        <Accordion defaultExpanded
                            key={challenge.ChallengeId}
                            classes={{
                                root: clsx(classes.rootAccordion, classes.active),
                                expanded: classes.expandedAccordion,
                                rounded: classes.roundedAccordion,
                            }}
                        >
                            <AccordionSummary
                                classes={{
                                    root: classes.rootAccordionSummaryForChallenge,
                                    content: classes.contentAccordionSummary,
                                    expanded: classes.expandedAccordionSummary,
                                }}
                            >
                                <Grid
                                    item xs={12}
                                    container
                                    justify="center"
                                    alignItems="center"
                                    classes={{ root: classes.rootGridContent }}
                                >
                                    <Grid item xs={12}>
                                        <div className={clsx(classes.textTitle)}>
                                            {challenge.ChallengeTitle}
                                        </div>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className={clsx(classes.textDescription)}>
                                            From {challenge.StartDate.split(' ')[0]} - To {challenge.EndDate.split(' ')[0]}
                                            {`  `}
                                            {
                                                !challenge.IsSignedUp ?
                                                    <Chip style={{ backgroundColor: '#ff5768', color: 'white' }}
                                                        label={`New`}
                                                    />
                                                    :
                                                    challenge.TeamMemberViewModels[0].Status !== "Pending" ?
                                                        <Chip style={{ backgroundColor: '#4DD091', color: 'white' }}
                                                            label={`Accepted`}
                                                        />
                                                        :
                                                        <Chip style={{ backgroundColor: '#cd950c', color: 'white' }}
                                                            label={`Pending`}
                                                        />
                                            }
                                        </div>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        container
                                        classes={{ root: classes.containerProrgessBar }}
                                    >
                                        <Grid item xs={12} classes={{ root: classes.wrapperProrgessBarCoin }}>
                                            <div className={clsx(classes.rootCoin)}>
                                                <Coin
                                                    coin={challenge.RewardCoins}
                                                    size="medium" />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </AccordionSummary>
                            <AccordionDetails>
                                {
                                    challenge.IsSignedUp ?
                                        challenge.TeamMemberViewModels[0].Status !== "Pending" ?
                                            <Typography color="secondary">
                                                You are participating in this challenge with Team {challenge.TeamName},
                                                click <a className="button one" onClick={() => handleClickOpen(challenge.ChallengeId)}>Here</a> to check your progress.
                                    </Typography>
                                            :
                                            challenge.SignUpBy.toLowerCase() === Claims.getGivenName().toLowerCase() ?
                                                <Typography color="secondary">
                                                    You have created Team {challenge.TeamName} for {challenge.ChallengeTitle},
                                        click <a className="button one" onClick={() => handleAccept(challenge.ChallengeId, challenge.TeamMemberViewModels[0].MemberId)}>
                                                        Here</a> to see the details.
                                        </Typography>
                                                :
                                                <Typography color="secondary">
                                                    Your friend has invited you to join Team {challenge.TeamName} for {challenge.ChallengeTitle},
                                        click <a className="button one" onClick={() => handleAccept(challenge.ChallengeId, challenge.TeamMemberViewModels[0].MemberId)}>
                                                        Here</a> to join the team.
                                        </Typography>
                                        :
                                        <Typography color="secondary">
                                            Please create a team to participate in this challenge, click <a className="button one" onClick={() => handleClickOpen(challenge.ChallengeId)}>Here</a> to see the details.
                                </Typography>
                                }
                            </AccordionDetails>
                        </Accordion>
                    ))
                    : <div>Watch this space for a new challenge!</div>
            }
            {
                rowsPerPage < challengeContext.onGoingChallenges.length &&
                <Grid classes={{ root: classes.containerLoadmore }} container justify="center" alignItems="center" onClick={() => onLoadMore()}>
                    <div>
                        Load more
                     </div>
                </Grid>
            }
        </>
    );
};

export { ChallengeHolder as default }
